module.exports = __webpack_public_path__ + "img/paul5.6726d0d4.jpg";